import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { SEO } from '../../../components/Seo/seo'
import { FormattedMessage, useIntl } from 'react-intl'
import Layout from '../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../routes'
import { editRole } from '../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { RoleProvider } from '../../../RoleContext'
import { FormLoader } from '../../../components/Loader/FormLoader'
import RoleEditContent from '../../../components/Dashboard/RoleEditContent'


const SingleRoleEdit = () => {
  let { id } = useParams()
  const intl = useIntl()
  return (
    <>
      {!!id && !!parseInt(id) ? <>
          <SEO title={intl.formatMessage({ id: 'Roles.List.EditRole.Title' })}
               pathname={window.location.origin}
               titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
               image={editRole.image}
               description={intl.formatMessage({ id: 'Roles.List.EditRole.Title' })}
          />
          <AuthenticatedUserConsumer>
            {({ userDataLoading, userData, handleNotificationCall, adminSectionType }) => (
              <>
                {!!userDataLoading && <FormLoader loading={true}/>}
                {!!Object.keys(userData).length &&
                <>
                  {!!userData.is_admin ? <Layout content={
                    <RoleProvider pageAction={'edit'} rid={id} adminSectionType={adminSectionType}
                                  handleNotificationCall={handleNotificationCall}>
                      <RoleEditContent adminSectionType={adminSectionType}
                                       pageTitle={<FormattedMessage id='Roles.List.EditRole.Title'/>}/>
                    </RoleProvider>
                  }/> : (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
                  }
                </>
                }
              </>
            )}
          </AuthenticatedUserConsumer>
        </> :
        <Redirect to={NamedRoutes.workspace.RolesAndPermissions.list}/>
      }
    </>
  )
}

export default SingleRoleEdit

